// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-0f89855d]{padding-top:3rem;padding-bottom:3rem;border-top:1px solid #dadfe2}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
